export const columnsCsv = [
  { key: "date", label: "DateTime" },
  { key: "email", label: "Email" },
  { key: "action", label: "Action" },
  { key: "actionOn", label: "Action On" },
 
];
export const options = [
  { value: "Admin", label: "Admin" },
  { value: "Call Centre Agent", label: "Call Centre Agent" },
  { value: "Customer Service Agent", label: "Customer Service Agent" },
  { value: "Super Admin", label: "Super Admin" },
];
